import { Select } from '@chakra-ui/core';
import styled from '@emotion/styled';

export const CustonSelect = styled(Select)`
  ::placeholder {
    color: #383539;
  }
`;
